import { createContext, useContext } from "react";

export type ToastVariant =
  | "error"
  | "info"
  | "loading"
  | "success"
  | "warning";

export type ToastAction = {
  href: string;
  label: string;
};

export type ToastInput = {
  action?: ToastAction;
  dedupeKey?: string;
  description?: string;
  durationMs?: number;
  title: string;
  variant: ToastVariant;
};

export type ToastUpdate = Partial<Omit<ToastInput, "action" | "dedupeKey">> & {
  action?: ToastAction | null;
};

export type ToastRecord = ToastInput & {
  id: string;
};

export type ToastApi = {
  dismiss: (id: string) => void;
  show: (toast: ToastInput) => string;
  update: (id: string, toast: ToastUpdate) => void;
};

export const ToastContext = createContext<ToastApi | undefined>(undefined);

export function useToasts() {
  const toasts = useContext(ToastContext);
  if (!toasts) {
    throw new Error("useToasts must be used inside ToastProvider.");
  }
  return toasts;
}
